import { render, staticRenderFns } from "./AccessibilityStats.vue?vue&type=template&id=7914009d&scoped=true&"
import script from "./AccessibilityStats.vue?vue&type=script&lang=js&"
export * from "./AccessibilityStats.vue?vue&type=script&lang=js&"
import style0 from "./accessibility-stats.css?vue&type=style&index=0&id=7914009d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7914009d",
  null
  
)

export default component.exports